import React, { useState } from 'react';
import ProductForm from './ProductForm';
import AdminProductCard from './AdminProductCard';
import CustomizationManager from './CustomizationManager';

const AdminPanel = ({ products, categories = [], onAddProduct, onUpdateProduct, onDeleteProduct, onShowNotification, customTypes, ingredients, onAddType, onUpdateType, onDeleteType, onAddIngredient, onUpdateIngredient, onDeleteIngredient }) => {
  const [showForm, setShowForm] = useState(false);
  const [editingProduct, setEditingProduct] = useState(null);

  const handleSubmit = (productData) => {
    if (editingProduct) {
      onUpdateProduct({ ...productData, id: editingProduct.id });
    } else {
      onAddProduct(productData);
    }
    setShowForm(false);
    setEditingProduct(null);
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="flex justify-between items-center mb-8">
        <h2 className="text-2xl font-bold text-gray-800">Gestión de Productos</h2>
        <button
          onClick={() => {
            setEditingProduct(null);
            setShowForm(true);
          }}
          className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
        >
          + Nuevo Producto
        </button>
      </div>

  {/* Admin tools moved to the central admin dashboard */}

      {showForm && (
        <div className="mb-8">
          <ProductForm
            product={editingProduct}
            categories={categories}
            onSubmit={handleSubmit}
            onCancel={() => {
              setShowForm(false);
              setEditingProduct(null);
            }}
          />
        </div>
      )}

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {products.map(product => (
          <AdminProductCard
            key={product.id}
            product={product}
            onEdit={(product) => {
              setEditingProduct(product);
              setShowForm(true);
            }}
            onDelete={onDeleteProduct}
          />
        ))}
      </div>
      <div className="mt-8">
        <CustomizationManager
          types={customTypes}
          ingredients={ingredients}
          onAddType={onAddType}
          onUpdateType={onUpdateType}
          onDeleteType={onDeleteType}
          onAddIngredient={onAddIngredient}
          onUpdateIngredient={onUpdateIngredient}
          onDeleteIngredient={onDeleteIngredient}
        />
      </div>
    </div>
  );
};

export default AdminPanel;